module.exports = {"svg":{"$":{"viewBox":"0 0 251 52","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"},"path":[{"$":{"d":"M0 22.0540541 0 28.9459459 237.77027 28.9459459 219.162162 46.1756757 223.986486 51.6891892 250.864865 26.1891892 223.986486 0 219.162162 4.82432432 237.081081 22.0540541z"}}]}}


//////////////////
// WEBPACK FOOTER
// ./~/xml-loader!./src/svg/icon-arrow--right.svg
// module id = 492
// module chunks = 0